import { render, staticRenderFns } from "./ActivePost.vue?vue&type=template&id=5e85ec3e&scoped=true&"
import script from "./ActivePost.vue?vue&type=script&lang=js&"
export * from "./ActivePost.vue?vue&type=script&lang=js&"
import style0 from "./ActivePost.vue?vue&type=style&index=0&id=5e85ec3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e85ec3e",
  null
  
)

export default component.exports